import { Pipe, PipeTransform } from '@angular/core';
import { AgeService } from './age.service';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  constructor(private service: AgeService) {}

  transform(birthdate: any): number {
    return this.service.instant(birthdate);
  }
}
